import { Navigate } from 'react-router-dom';
import { readCurrentJob } from '@/components/jobs/current-job';

/**
 * `/capture`, the Capture tab. There is no capture without a job
 * (CAPTURE_JOBS.md section 6), so this route draws nothing of its own: it
 * opens the viewfinder for the job the operator chose from My jobs, and
 * My jobs itself when none has been chosen in this sitting.
 */
export function CaptureEntry() {
  const job = readCurrentJob();
  return <Navigate to={job ? `/jobs/${encodeURIComponent(job.jobId)}/capture` : '/work'} replace />;
}
